export class ContactFile {
    public id: number | null;
    public document_name: string ;
    public created_by_user: string ;
    public createdAt: Date|null;

    constructor(data: ContactFileData | void) {
        if (data === undefined) {
            this.id = null;
            this.document_name = "";
            this.created_by_user = "";
            this.createdAt = null;
        } else {
            this.id = data.id;
            this.document_name = data.document_name;
            this.created_by_user = data.created_by_user;
            this.createdAt = data.createdAt;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.document_name = "";
        this.created_by_user = "";
        this.createdAt = null;
    }
    serializeData():ContactFileData {
        return {
            id: this.id,
            document_name: this.document_name,
            created_by_user: this.created_by_user,
            createdAt: this.createdAt,
        }
    }
}

export type ContactFileData = {
    id:number|null;
    document_name:string;
    created_by_user:string;
    createdAt:Date|null;
}